import { useTheme, useMediaQuery } from '@mui/material';
import PreCampagnaListPageDesktop from './PreCampagnaListPageDesktop';
import PreCampagnaListPageMobile from './PreCampagnaListPageMobile';

export default function PreCampagnaListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <PreCampagnaListPageMobile />
    : <PreCampagnaListPageDesktop />;
}